export default __webpack_public_path__ + "static/media/JobupdatesIcon.9a67b3d0.svg";